import React from 'react';
import HeaderRlt2 from './HeaderRlt2';
import TestimonialCardRlt2 from './TestimonialCardRlt2';
import CTAButtonRlt1 from './CTAButtonRlt1';
import TimelineEventRlt2 from './TimelineEventRlt2';
import FeaturePointRlt2 from './FeaturePointRlt2';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon } from 'lucide-react';
const AdvertorialRlt2 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-5078">
      <HeaderRlt2 data-id="element-5079" />
      <main className="px-4 sm:px-8 py-8" data-id="element-5080">
        <div className="prose max-w-none" data-id="element-5081">
          <div className="flex items-center text-xs text-gray-500 mb-8 border-b border-gray-200 pb-2" data-id="element-5082">
            <div className="flex items-center mr-4" data-id="element-5083">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-5084" />
              <span data-id="element-5085">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-5086">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-5087" />
              <span data-id="element-5088">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5089">
            If you'd told me three years ago that shining red light on your
            stomach could drain fat cells, I would have dismissed it as wellness
            nonsense. Then I read the research. Then I tested 8 devices on 14
            volunteers for 12 weeks. What I discovered explains why most people
            fail—and why one device produced results that matched the clinical
            trials.
          </p>

          <div className="flex justify-center mb-6" data-id="element-5090"></div>

          <div className="flex justify-center mb-6" data-id="element-5091">
            <div className="w-full sm:w-2/3 bg-gray-50 p-5 rounded border border-gray-300 text-sm" data-id="element-5092">
              <div className="uppercase text-gray-600 text-xs font-sans tracking-wider mb-3 font-medium border-b border-gray-300 pb-2" data-id="element-5093">
                Who This Is For
              </div>
              <div className="space-y-3" data-id="element-5094">
                <div className="flex items-start" data-id="element-5095">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5096" />
                  <span className="text-sm text-gray-700" data-id="element-5097">
                    Women in perimenopause or menopause dealing with stubborn
                    midsection fat
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5098">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5099" />
                  <span className="text-sm text-gray-700" data-id="element-5100">
                    Anyone on GLP-1 medications with pockets that won't respond
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5101">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5102" />
                  <span className="text-sm text-gray-700" data-id="element-5103">
                    People already doing everything right with one stubborn area
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5104">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5105" />
                  <span className="text-sm text-gray-700" data-id="element-5106">
                    Post-pregnancy women with persistent abdominal fat
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5107">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5108" />
                  <span className="text-sm text-gray-700" data-id="element-5109">
                    Men with love handles that won't respond to cutting
                  </span>
                </div>
                <div className="flex items-start" data-id="element-5110">
                  <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-5111" />
                  <span className="text-sm text-gray-700" data-id="element-5112">
                    Anyone who tried red light before and only got skin benefits
                  </span>
                </div>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5113">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5114"></span>
            The Science I Couldn't Dismiss
          </h2>

          <p className="mb-5 text-base" data-id="element-5115">
            I spent twenty years telling clients that spot reduction was a myth.
            That fat loss was systemic. That you couldn't "target" stubborn
            areas with anything short of liposuction.
          </p>

          <p className="mb-5 text-base" data-id="element-5116">
            Then a colleague sent me a stack of peer-reviewed papers. I expected
            to debunk them in an afternoon.
          </p>

          <p className="mb-5 text-base" data-id="element-5117">Instead, I found:</p>

          <div className="space-y-4 mb-6" data-id="element-5118">
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5119">
              <strong data-id="element-5120">Journal of Obesity Surgery:</strong> Double-blind,
              placebo-controlled trial. 3.27 inches lost across waist, hips, and
              thighs in two weeks. Placebo group: 0.35 inches. Statistical
              significance: p &lt; 0.001.
            </p>
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5121">
              <strong data-id="element-5122">Lasers in Surgery and Medicine:</strong> Electron
              microscopy showing 80% of fat cell contents evacuated after just 6
              minutes of red light exposure. Researchers watched the cells
              deflate in real-time under the microscope.
            </p>
            <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5123">
              <strong data-id="element-5124">Journal of Clinical and Aesthetic Dermatology:</strong>{' '}
              5.4 inches of combined circumference reduction at six weeks. Zero
              adverse events. Excellent safety profile.
            </p>
          </div>

          <p className="mb-5 text-base" data-id="element-5125">
            And in 2010, the FDA cleared this technology for "circumferential
            reduction of waist, hips, and thighs." Not for general wellness or
            for skin health. For measurable fat reduction.
          </p>

          <p className="mb-5 text-base" data-id="element-5126">
            I sat with these papers for a week. The mechanism was elegant. The
            results were reproducible across multiple trials. This wasn't
            wellness marketing—this was documented physics.
          </p>

          <p className="mb-6 text-base" data-id="element-5127">
            So I needed to understand: how does shining a light actually empty a
            fat cell?
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5128">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5129"></span>
            How Red Light Actually Drains Fat
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5130">
            <img src="https://cdn.magicpatterns.com/uploads/94QarDWvbki4GiuN3uHoSY/LNgNIr1pKH59ptOZpPCi1.png" alt="Diagram showing fat cell deflation process - temporary pores release triglycerides into interstitial space, which are picked up by lymphatic vessels for energy oxidation" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5131" />
          </div>

          <p className="mb-5 text-base" data-id="element-5132">
            Think of your fat cell like a water balloon. The red light at 660nm
            wavelength essentially pokes tiny holes in it. The
            contents—triglycerides, fatty acids, glycerol—leak out through these
            pores.
          </p>

          <p className="mb-5 text-base" data-id="element-5133">
            The cell doesn't die. It deflates. Like a grape becoming a raisin.
          </p>

          <p className="mb-5 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5134">
            Now here's the important part: the fat doesn't disappear from your
            body immediately. It leaks into your interstitial fluid, gets picked
            up by your lymphatic system, and enters your bloodstream.
          </p>

          <p className="mb-5 text-base" data-id="element-5135">
            From there, your body can burn it as energy—when you're moving.
          </p>

          <p className="mb-5 text-base" data-id="element-5136">
            This is why red light therapy requires movement afterward. The light
            unlocks the fat. Your activity burns it.
          </p>

          <p className="mb-6 text-base" data-id="element-5137">
            Reading this research changed my assumptions. The mechanism was
            elegant. The physics were sound. The clinical results were
            reproducible.
          </p>

          <p className="mb-5 text-base" data-id="element-5138">
            So I started recommending red light therapy to clients with stubborn
            fat.
          </p>

          <p className="mb-6 text-base" data-id="element-5139">And that's when the confusion began.</p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5140">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5141"></span>
            The Gap Between Research and Reality
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5142">
            <img src="https://cdn.magicpatterns.com/uploads/6ggWu49BBf5fW7TQq7yHWL/JnLOkUasoxzuzYRTXpOo6.png" alt="Medical professional consulting with patient using red light therapy device" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5143" />
          </div>

          <p className="mb-5 text-base" data-id="element-5144">
            Over the past two years, I've recommended red light therapy to
            dozens of clients.
          </p>

          <p className="mb-5 text-base" data-id="element-5145">
            The clinical research promised 3-5 inches of reduction.
          </p>

          <p className="mb-5 text-base" data-id="element-5146">
            My clients were seeing maybe half an inch. Sometimes an inch. A
            fraction of what the studies showed.
          </p>

          <p className="mb-5 text-base" data-id="element-5147">
            They reported other benefits—tighter skin, smoother texture, reduced
            inflammation. The devices were doing something. But the dramatic fat
            reduction from the clinical trials wasn't really happening.
          </p>

          <p className="mb-5 text-base" data-id="element-5148">
            Online communities told the same story— people using devices for
            months, getting skin benefits, but no fat loss. Satisfaction rate
            for fat loss specifically: around 20-25%.
          </p>

          <p className="mb-5 text-base" data-id="element-5149">
            The mechanism was real, the studies were legitimate, and the FDA
            clearance was based on actual clinical outcomes - it was definitely
            not one of the internet gimmicks we see all the time.
          </p>

          <p className="mb-5 text-base" data-id="element-5150">
            So what would it actually take to see the results the research
            promised?
          </p>

          <p className="mb-5 text-base" data-id="element-5151">
            Something in the chain was broken. I decided to find out what.
          </p>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5152">
            What I later found explained why most devices fail—and the only way
            to actually drain stubborn fat from targeted areas. Something that
            wasn't possible without a surgery just 20 years ago.
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5153">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5154"></span>
            The Investigation: 8 Devices, 14 Volunteers, 12 Weeks
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5155">
            <img src="https://cdn.magicpatterns.com/uploads/31NywSxade2JCjwYchvFWq/ztdKjRAdxq3qizduNv4qV.png" alt="Eight red light therapy devices tested - product boxes arranged on porch" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5156" />
          </div>

          <p className="mb-5 text-base" data-id="element-5157">
            I purchased eight red light therapy devices marketed specifically
            for fat loss and recruited 14 volunteers for a controlled 12-week
            study.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5158">
            The Volunteers
          </h3>

          <div className="space-y-3 mb-6 bg-gray-50 p-5 rounded border border-gray-300" data-id="element-5159">
            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5160">
              <div className="flex items-start gap-3" data-id="element-5161">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5162">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5163">M</span>
                </div>
                <div className="flex-1" data-id="element-5164">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5165">
                    <strong className="text-base" data-id="element-5166">Maria, 54</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5167" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5168">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5169">
                    On Mounjaro for 10 months. Lost 47 pounds but her lower
                    belly hadn't budged in the last four months despite
                    continued medication and consistent walking.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5170">
              <div className="flex items-start gap-3" data-id="element-5171">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5172">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5173">J</span>
                </div>
                <div className="flex-1" data-id="element-5174">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5175">
                    <strong className="text-base" data-id="element-5176">Jennifer, 49</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5177" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5178">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5179">
                    Perimenopausal. Gained 15 pounds around her midsection over
                    two years despite no change in diet or exercise. Classic
                    hormonal redistribution. Her doctor called it "menopause
                    belly."
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5180">
              <div className="flex items-start gap-3" data-id="element-5181">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5182">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5183">D</span>
                </div>
                <div className="flex-1" data-id="element-5184">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5185">
                    <strong className="text-base" data-id="element-5186">David, 58</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5187" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5188">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5189">
                    Avid cyclist, 200 miles per week. Measured at 18% body fat
                    but persistent love handles that wouldn't respond to caloric
                    deficits or increased cardio.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5190">
              <div className="flex items-start gap-3" data-id="element-5191">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5192">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5193">R</span>
                </div>
                <div className="flex-1" data-id="element-5194">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5195">
                    <strong className="text-base" data-id="element-5196">Rachel, 38</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5197" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5198">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5199">
                    18 months postpartum. Back to pre-pregnancy weight but
                    stubborn lower abdominal fat remained. "I've tried
                    everything," she told me. "This pouch won't leave."
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5200">
              <div className="flex items-start gap-3" data-id="element-5201">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5202">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5203">T</span>
                </div>
                <div className="flex-1" data-id="element-5204">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5205">
                    <strong className="text-base" data-id="element-5206">Tom, 44</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5207" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5208">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5209">
                    Lost 60 pounds over two years through diet and exercise.
                    Left with stubborn flank fat and loose skin. Had tried two
                    other red light devices with minimal results.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-5 rounded-lg border-2 border-blue-100 shadow-sm" data-id="element-5210">
              <div className="flex items-start gap-3" data-id="element-5211">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5212">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5213">L</span>
                </div>
                <div className="flex-1" data-id="element-5214">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5215">
                    <strong className="text-base" data-id="element-5216">Linda, 61</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5217" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5218">
                      Verified Participant
                    </span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-5219">
                    Post-menopausal for six years. Frustrated that her body
                    "stopped listening" to the same routine that kept her lean
                    for decades. Midsection thickening despite no lifestyle
                    changes.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-6 text-base" data-id="element-5220">
            Plus six additional volunteers—men and women aged 38-67, each with
            documented stubborn fat deposits that had resisted conventional
            approaches.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5221">
            The Devices
          </h3>

          <div className="overflow-x-auto mb-6" data-id="element-5222">
            <table className="min-w-full border border-gray-300 text-sm" data-id="element-5223">
              <thead className="bg-gray-100" data-id="element-5224">
                <tr data-id="element-5225">
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5226">
                    Device
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5227">
                    Wavelength
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5228">
                    LED Count
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5229">
                    Power
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5230">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-5231">
                <tr data-id="element-5232">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5233">
                    NuShape Lipo Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5234">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5235">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5236">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5237">$149</td>
                </tr>
                <tr data-id="element-5238">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5239">
                    MitoRed Belt Pro
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5240">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5241">144</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5242">72W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5243">$289</td>
                </tr>
                <tr data-id="element-5244">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5245">
                    Bestqool Body Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5246">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5247">105</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5248">50W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5249">$89</td>
                </tr>
                <tr data-id="element-5250">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5251">
                    InfraGlow Contour Belt
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5252">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5253">132</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5254">65W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5255">$199</td>
                </tr>
                <tr data-id="element-5256">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5257">
                    RedRush 360
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5258">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5259">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5260">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5261">$129</td>
                </tr>
                <tr data-id="element-5262">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5263">
                    TheraBelt Plus
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5264">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5265">108</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5266">55W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5267">$169</td>
                </tr>
                <tr data-id="element-5268">
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5269">
                    LumoWrap Basic
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5270">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5271">90</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5272">45W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5273">$59</td>
                </tr>
                <tr className="border border-gray-300 px-3 py-2" data-id="element-5274">
                  <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5275">
                    Glokore Deep Red Light Wrap
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5276">
                    660nm / 850nm
                  </td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5277">120</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5278">60W</td>
                  <td className="border border-gray-300 px-3 py-2" data-id="element-5279">$179</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mb-5 text-base" data-id="element-5280">Look at these specifications.</p>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5281">
            Same wavelengths across the board—the 660nm red and 850nm infrared
            that research validated. Similar LED counts. Comparable power
            outputs. Price ranging from budget to premium.
          </p>

          <p className="mb-6 text-base" data-id="element-5282">
            If specifications told the whole story, results should be roughly
            similar.
          </p>

          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-5283">
            The Protocol
          </h3>

          <div className="border border-gray-300 p-5 my-6 bg-gray-50 rounded" data-id="element-5284">
            <ul className="space-y-2 text-base" data-id="element-5285">
              <li data-id="element-5286">• 20 minutes per session, 5 days per week</li>
              <li data-id="element-5287">
                • Device applied directly to stubborn area (skin contact
                required)
              </li>
              <li data-id="element-5288">• Followed immediately by 30 minutes of moderate walking</li>
              <li data-id="element-5289">• 8+ glasses of water daily</li>
              <li data-id="element-5290">• No dietary changes required (we weren't testing diet)</li>
              <li data-id="element-5291">• Weekly measurements, monthly photos</li>
            </ul>
          </div>

          <p className="mb-6 text-base italic text-blue-900 bg-blue-50 border-l-4 border-blue-500 pl-4 py-3" data-id="element-5292">
            According to the clinical research, every single one of these
            volunteers should see 3-5 inches of reduction within weeks. The
            stubborn fat that resisted everything else should finally start
            draining.
          </p>

          <div className="mt-12 mb-10" data-id="element-5293">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5294">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5295"></span>
              Week 1-2: Everything Works
            </h2>

            <p className="mb-5 text-base" data-id="element-5296">
              The first two weeks looked promising across the board.
            </p>

            <p className="mb-5 text-base" data-id="element-5297">
              Every device showed some reduction. Small—0.2 to 0.5 inches—but
              measurable movement. Volunteers reported their skin feeling
              tighter, looking smoother. Some noticed reduced bloating.
            </p>

            <div className="overflow-x-auto mb-6" data-id="element-5298">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5299">
                <thead className="bg-gray-100" data-id="element-5300">
                  <tr data-id="element-5301">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5302">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5303">
                      Week 2 Waist
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5304">
                      Week 2 Thigh
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5305">
                  <tr data-id="element-5306">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5307">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5308">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5309">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5310">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5311">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5312">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5313">
                      -0.3"
                    </td>
                  </tr>
                  <tr data-id="element-5314">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5315">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5316">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5317">
                      -0.1"
                    </td>
                  </tr>
                  <tr data-id="element-5318">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5319">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5320">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5321">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5322">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5323">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5324">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5325">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5326">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5327">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5328">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5329">
                      -0.2"
                    </td>
                  </tr>
                  <tr data-id="element-5330">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5331">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5332">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5333">
                      -0.1"
                    </td>
                  </tr>
                  <tr data-id="element-5334">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5335">
                      Glokore Deep RLT
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5336">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5337">
                      -0.3"
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mb-5 text-base" data-id="element-5338">
              Small numbers, but movement across the board. At this point, there
              was no clear winner.
            </p>

            <p className="mb-6 text-base italic" data-id="element-5339">
              "Maybe they all work," I wrote in my notes. "Maybe the price
              differences are just marketing."
            </p>

            <p className="mb-6 text-base" data-id="element-5340">I was wrong.</p>
          </div>

          <div className="mt-12 mb-10" data-id="element-5341">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5342">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5343"></span>
              Week 4-6: The Split
            </h2>

            <p className="mb-5 text-base" data-id="element-5344">
              By week six, the pattern had fractured.
            </p>

            <p className="mb-5 text-base" data-id="element-5345">
              Seven devices had plateaued completely. Measurements stopped
              improving. Some volunteers actually saw slight increases as
              initial water weight fluctuations normalized.
            </p>

            <div className="overflow-x-auto mb-6" data-id="element-5346">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5347">
                <thead className="bg-gray-100" data-id="element-5348">
                  <tr data-id="element-5349">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5350">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5351">
                      Week 6 Waist
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5352">
                      Week 6 Thigh
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5353">
                      Trend
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5354">
                  <tr data-id="element-5355">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5356">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5357">
                      -0.8"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5358">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5359">
                      Slowing
                    </td>
                  </tr>
                  <tr data-id="element-5360">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5361">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5362">
                      -0.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5363">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-yellow-600 font-medium" data-id="element-5364">
                      Slowing
                    </td>
                  </tr>
                  <tr data-id="element-5365">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5366">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5367">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5368">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5369">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5370">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5371">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5372">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5373">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5374">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5375">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5376">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5377">
                      -0.5"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5378">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5379">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5380">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5381">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5382">
                      -0.4"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5383">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5384">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5385">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5386">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5387">
                      -0.3"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5388">
                      -0.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-red-600 font-medium" data-id="element-5389">
                      Stopped
                    </td>
                  </tr>
                  <tr data-id="element-5390">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5391">
                      Glokore Deep RLT
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5392">
                      -1.2"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5393">
                      -0.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-green-600 font-medium" data-id="element-5394">
                      Continuing
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-12 mb-10" data-id="element-5395">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5396">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5397"></span>
              Week 8-10: The Separation Widens
            </h2>

            <div className="flex justify-center mb-8" data-id="element-5398">
              <img src="https://cdn.magicpatterns.com/uploads/weoEoLHvJyz4DGeD9N3kv8/v_7tH-HZydCx26l54zzk_.png" alt="Red light therapy devices and research materials on desk" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5399" />
            </div>

            <p className="mb-5 text-base" data-id="element-5400">
              By week ten, the gap was undeniable.
            </p>

            <p className="mb-5 text-base italic border-l-4 border-red-500 pl-4 text-gray-700" data-id="element-5401">
              Seven devices had delivered their full results by week 4. Nothing
              further. Volunteers using them had seen somewhere between 0.4 and
              0.9 inches of total reduction—roughly 10-25% of what the clinical
              studies promised.
            </p>

            <p className="mb-5 text-base" data-id="element-5402">
              Only one device was still delivering the measurable results.
            </p>

            <p className="mb-5 text-base" data-id="element-5403">
              Linda, 61, had been skeptical from the start, but by week ten, she
              was down 2.1 inches on her waist. "I keep checking the measuring
              tape because I don't believe it."
            </p>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5404">
              <div className="flex items-start gap-3 mb-3" data-id="element-5405">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5406">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5407">L</span>
                </div>
                <div className="flex-1" data-id="element-5408">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5409">
                    <strong className="text-base" data-id="element-5410">Linda, 61</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5411" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5412">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 font-medium" data-id="element-5413">
                    Week 10
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5414">
                "At my age, I figured menopause had won...In 10 weeks with Dr.
                Sarah Mitchell I saw my waist reduced by 2.1 inches... And all I
                had to do was use the red light therapy wrap, walk and drink
                water. I keep checking the measure tape because I can't believe
                it! This is just awesome."
              </p>
            </div>
          </div>

          <div className="mt-12 mb-10" data-id="element-5415">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-5416">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5417"></span>
              Week 12: Final Results
            </h2>

            <div className="overflow-x-auto mb-6" data-id="element-5418">
              <table className="min-w-full border border-gray-300 text-sm" data-id="element-5419">
                <thead className="bg-gray-100" data-id="element-5420">
                  <tr data-id="element-5421">
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5422">
                      Device
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5423">
                      Avg. Waist Reduction
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5424">
                      Avg. Thigh Reduction
                    </th>
                    <th className="border border-gray-300 px-3 py-2 text-left" data-id="element-5425">
                      Still Improving at Week 12?
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-5426">
                  <tr data-id="element-5427">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5428">
                      NuShape Lipo Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5429">0.8"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5430">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5431">
                      No (plateaued week 6)
                    </td>
                  </tr>
                  <tr data-id="element-5432">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5433">
                      MitoRed Belt Pro
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5434">0.9"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5435">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5436">
                      No (plateaued week 7)
                    </td>
                  </tr>
                  <tr data-id="element-5437">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5438">
                      Bestqool Body Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5439">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5440">0.2"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5441">
                      No (plateaued week 3)
                    </td>
                  </tr>
                  <tr data-id="element-5442">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5443">
                      InfraGlow Contour Belt
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5444">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5445">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5446">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5447">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5448">
                      RedRush 360
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5449">0.6"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5450">0.4"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5451">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5452">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5453">
                      TheraBelt Plus
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5454">0.5"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5455">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5456">
                      No (plateaued week 4)
                    </td>
                  </tr>
                  <tr data-id="element-5457">
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5458">
                      LumoWrap Basic
                    </td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5459">0.3"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5460">0.2"</td>
                    <td className="border border-gray-300 px-3 py-2" data-id="element-5461">
                      No (plateaued week 3)
                    </td>
                  </tr>
                  <tr className="bg-green-50" data-id="element-5462">
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5463">
                      Glokore Deep Red Light Wrap
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5464">
                      2.7"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5465">
                      1.6"
                    </td>
                    <td className="border border-gray-300 px-3 py-2 font-medium" data-id="element-5466">
                      Yes
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mb-5 text-base" data-id="element-5467">
              Same wavelengths. Same LED counts. Same protocols. Same volunteer
              demographics.
            </p>

            <p className="mb-5 text-base" data-id="element-5468">Completely different outcomes.</p>

            <p className="mb-5 text-base" data-id="element-5469">
              The Glokore device produced 3-4x the results of everything else
              tested. And it was still working at week 12 when everything else
              had stalled months earlier.
            </p>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5470">
              <div className="flex items-start gap-3 mb-3" data-id="element-5471">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5472">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5473">S</span>
                </div>
                <div className="flex-1" data-id="element-5474">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5475">
                    <strong className="text-base" data-id="element-5476">Susan, 47</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5477" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5478">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-600 font-medium mb-2" data-id="element-5479">
                    On Wegovy for 8 months, lost 55 pounds:
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5480">
                "My waist wouldn't budge no matter what. The medication did
                everything except touch that one area. But now—2.4 inches gone
                in 12 weeks—more than the last four months of Wegovy combined."
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border-2 border-blue-100 shadow-sm mb-6" data-id="element-5481">
              <div className="flex items-start gap-3 mb-3" data-id="element-5482">
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-5483">
                  <span className="text-blue-700 font-bold text-sm" data-id="element-5484">R</span>
                </div>
                <div className="flex-1" data-id="element-5485">
                  <div className="flex items-center gap-2 mb-1" data-id="element-5486">
                    <strong className="text-base" data-id="element-5487">Rachel, 38</strong>
                    <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-5488" />
                    <span className="text-xs text-blue-600 font-medium" data-id="element-5489">
                      Verified Participant
                    </span>
                  </div>
                  <div className="text-xs text-gray-600 font-medium mb-2" data-id="element-5490">
                    18 months postpartum:
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic border-l-4 border-blue-500 pl-4" data-id="element-5491">
                "I cried when I measured week 10. I've been fighting this pouch
                since my son was born. Eighteen months of hating what I saw in
                the mirror. I thought it was permanent. This investigation
                really helped, I'll stick to red light therapy now."
              </p>
            </div>

            <p className="mb-6 text-base" data-id="element-5492">
              I needed to understand why this one device worked when seven
              others—with nearly identical specifications—had failed.
            </p>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5493">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5494"></span>
            Tracking Down the Mystery
          </h2>

          <p className="mb-5 text-base" data-id="element-5495">
            Glokore was a company I'd never heard of.
          </p>

          <p className="mb-5 text-base" data-id="element-5496">Small operation out of Kentucky.</p>

          <p className="mb-5 text-base" data-id="element-5497">Basic website, no flashy marketing.</p>

          <p className="mb-5 text-base" data-id="element-5498">
            Yet their device outperformed everything else in my study by 3-4x.
          </p>

          <div className="flex justify-center mb-8" data-id="element-5499">
            <img src="https://cdn.magicpatterns.com/uploads/oMyAjnUEAxXSsezjHjcbJ4/pasted-image.png" alt="Email from Dr. Sarah Mitchell to Rob Hartley about red light therapy device investigation" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5500" />
          </div>

          <p className="mb-5 text-base" data-id="element-5501">
            I found the founder's email and reached out.
          </p>

          <p className="mb-6 text-base" data-id="element-5502">The next morning, my phone rang.</p>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5503">
            "Dr. Mitchell? This is Rob Hartley. I've been wondering when someone
            would actually test these devices properly."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5504">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5505"></span>
            The Oceaneering Engineer Who Fixed Red Light Therapy
          </h2>
          <div className="flex justify-center mb-8" data-id="element-5506">
            <img src="https://cdn.magicpatterns.com/uploads/gFCtxBWZ6AqXKvFktbuQnL/0sYaq6YkSHENC7FSYjD19.png" alt="Rob Hartley, retired optical engineer from Oceaneering International, in his office" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5507" />
          </div>
          <p className="mb-5 text-base" data-id="element-5508">
            Rob wasn't what I expected. A retired optical engineer who spent 32
            years at Oceaneering International—the company that builds
            illumination systems for deep-sea submersibles. He'd designed lights
            that explored the Titanic. The Mariana Trench. Equipment where
            failure meant losing million-dollar missions.
          </p>

          <p className="mb-6 text-base leading-relaxed italic border-l-4 border-gray-400 pl-4 text-gray-700" data-id="element-5509">
            "My wife Karen is why this exists," he started. "She tried every red
            light device on the market. Her skin looked great. But the stubborn
            fat? Nothing. Months of use. Nothing."
          </p>

          <p className="mb-5 text-base" data-id="element-5510">
            "That's exactly what my volunteers experienced," I said.
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5511">
            "Right. So I did what engineers do—I took the devices apart."
          </p>

          <p className="mb-5 text-base" data-id="element-5512">What he found explained everything.</p>

          <p className="mb-5 text-base" data-id="element-5513">
            "Bare LEDs. Exposed diodes soldered onto a flexible strip. Light
            spraying in every direction—forward, sideways, even backward into
            the housing."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5514">
            <img src="https://cdn.magicpatterns.com/uploads/c9fo2NbifB1Yzomx5ULCAW/KrEphB53It6oUW-2OWBRE.png" alt="Thermal imaging showing bare LED light scattering at surface - energy trapped at surface while fat layer remains cold and untouched by light" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5515" />
          </div>

          <p className="mb-5 text-base" data-id="element-5516">
            "Most of these devices were built for skin. Tightening. Healing.
            Collagen. That's what red light does at the surface, and that's what
            they were designed for."
          </p>

          <p className="mb-5 text-base" data-id="element-5517">
            "Then the fat-loss research came out. Manufacturers saw a new
            market. Suddenly every skin belt was being advertised for 'fat
            reduction.' Same device. New marketing. But they didn't change
            anything about the engineering."
          </p>

          <p className="mb-5 text-base" data-id="element-5518">
            "They're selling skin devices for a fat problem."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5519">
            "Your fat cells aren't on the surface. They're four to eight
            millimeters deep. For red light to drain them, it has to actually
            REACH them. These devices scatter light across the skin. Great for
            collagen. But it disperses before reaching the fat layer."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5520">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5521"></span>
            The Deep-Sea Solution
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5522">
            <img src="https://cdn.magicpatterns.com/uploads/fi1rDxyr8r4fF8X1CPLSFd/curtin_university_sydney_expedition.webp" alt="Deep-sea submersible with precision lighting system exploring underwater wreckage" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5523" />
          </div>

          <p className="mb-5 text-base" data-id="element-5524">"So how did you fix it?" I asked.</p>

          <p className="mb-5 text-base" data-id="element-5525">
            "At the bottom of the ocean, scattered light is useless. Creates
            backscatter—a blinding white haze. You can't photograph the Titanic
            if your lights are spraying everywhere."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5526">
            "So what do we do? Reflector housings. Every light sits inside a
            precision-machined reflector that catches any photon trying to
            escape sideways and redirects it forward. Specific beam angles.
            Every photon travels where it needs to go, or the mission fails."
          </p>

          <p className="mb-5 text-base" data-id="element-5527">"Same principle here."</p>

          <p className="mb-5 text-base" data-id="element-5528">
            "Think of a garden hose. Wide spray—water goes everywhere but no
            pressure. No penetration. That's what standard devices do."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5529">
            <img src="https://cdn.magicpatterns.com/uploads/i2EZAKSCiq86cMHcfyrspk/RN8avCG-fTj-fZDLrCZYN.png" alt="Thermal imaging comparison showing reflector-backed deep LED penetrating energy through surface into warm fat layer being deflated by light" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5530" />
          </div>

          <p className="mb-5 text-base" data-id="element-5531">
            "Turn it to jet. Same water, but it PUNCHES. It penetrates."
          </p>

          <p className="mb-5 text-base" data-id="element-5532">
            "That's why your volunteers kept losing inches when everyone else
            plateaued. My light isn't scattering at the surface. It's punching
            through to the fat layer. Every session, it's actually reaching the
            cells. Every session, it's draining them. Week after week."
          </p>

          <p className="mb-6 text-base" data-id="element-5533">
            "That's what I built for Karen. And that's why it works."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5534">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5535"></span>
            The $488,719 Investment
          </h2>

          <p className="mb-5 text-base" data-id="element-5536">
            "This sounds expensive to manufacture," I said.
          </p>

          <p className="mb-5 text-base" data-id="element-5537">
            "Three of us from Oceaneering pooled our 401Ks. About half a million
            dollars. Precision molding equipment to produce reflector housings
            at the tolerances we needed. You can't order these from a
            supplier—nobody makes them."
          </p>

          <div className="flex justify-center mb-8" data-id="element-5538">
            <img src="https://cdn.magicpatterns.com/uploads/2WtZ6Jz8grSFbxkog1zBSF/YKe82QRXFzp6UlytzkQbn.png" alt="Precision injection molding equipment manufacturing LED reflector housings with robotic arm and quality control display" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5539" />
          </div>

          <p className="mb-5 text-base" data-id="element-5540">"Your wife must have loved that."</p>

          <p className="mb-6 text-base" data-id="element-5541">
            "She said if it didn't work, I was sleeping in the garage for the
            rest of my life." He paused. "It worked."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5542">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5543"></span>
            The Proof
          </h2>

          <div className="flex justify-center mb-8" data-id="element-5544">
            <img src="https://cdn.magicpatterns.com/uploads/9pGL49nw5juDn56U9egbr5/gcanCRJjpCeAwLF40yXo2.png" alt="Robert Hartley on Zoom call demonstrating the Deep Red Light Therapy Wrap with reflector-backed LEDs in his home office" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5545" />
          </div>

          <p className="mb-5 text-base" data-id="element-5546">
            "When Karen used the prototype, she saw what the clinical studies
            promised," Rob said. "1.9 inches off her waist in the first month.
            Still going at month two. The stubborn fat that hadn't moved in
            years—finally moving."
          </p>

          <p className="mb-5 text-base" data-id="element-5547">
            "That's exactly what I saw with my volunteers," I told him.
            "Everyone using your device kept losing. Everyone else plateaued by
            week four."
          </p>

          <p className="mb-5 text-base" data-id="element-5548">
            "If it doesn't actually work, what's the point?" he said.
          </p>

          <p className="mb-5 text-base" data-id="element-5549">
            "How are people even finding you?" I asked. "You have a unique
            technology but your website is basic. I don't see any ads or
            influencers."
          </p>

          <p className="mb-5 text-base" data-id="element-5550">
            "Word spreads. Started in my town in Kentucky. Someone tells their
            sister in Ohio. She tells her friend in Connecticut. I don't
            advertise. I just make them and ship them to people who heard it
            actually works."
          </p>

          <p className="mb-5 text-base" data-id="element-5551">I asked him why he called it "Deep."</p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5552">
            "Because that's what it does. It goes DEEP. Past the epidermis. Past
            the dermis. Into the fat layer where the drainage actually happens.
            Every other device stops at the surface. This one doesn't."
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5553">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5554"></span>
            The Email From Rob That Won My Heart
          </h2>

          <p className="mb-5 text-base" data-id="element-5555">
            After I shared my study results with Rob, he sent an email I didn't
            expect:
          </p>

          <div className="flex justify-center mb-8" data-id="element-5556">
            <img src="https://cdn.magicpatterns.com/uploads/fAZSSkMNzVAU5qsDtERS8v/pasted-image.png" alt="Email from Robert Hartley thanking Dr. Mitchell for the investigation and offering readers access to the belt at production cost" className="w-full max-w-2xl rounded border border-gray-300" data-id="element-5557" />
          </div>

          <p className="mb-5 text-base" data-id="element-5558">I called him immediately.</p>

          <p className="mb-5 text-base" data-id="element-5559">
            "Rob, you can't be serious about selling at production cost."
          </p>

          <p className="mb-5 text-base" data-id="element-5560">
            "Sarah, these manufacturers are selling people skin devices
            and promising fat loss. It doesn't work. People blame themselves
            when they should be blaming the engineering."
          </p>

          <p className="mb-3 text-base bg-yellow-100 p-3 border-l-4 border-yellow-400" data-id="element-5561">
            "If your investigation helps people find a device that actually
            reaches the fat layer AND saves them money? That's worth more to me
            than margin. Once they measure the results themselves, word spreads.
            That's the only marketing I need."
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5562">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5563">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5564">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5565" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5566">
              Limited to current inventory of 340 units
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5567">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5568"></span>
            Who This Is For
          </h2>

          <p className="mb-5 text-base" data-id="element-5569">
            Based on my investigation, this device produces the best results
            for:
          </p>

          <div className="space-y-3 mb-8 border border-gray-300 p-5 bg-gray-50 rounded" data-id="element-5570">
            <FeaturePointRlt2 data-id="element-5571">
              Women in perimenopause or menopause dealing with the hormonal
              redistribution that creates stubborn midsection fat—the "menopause
              belly" that appears even when diet and exercise stay consistent.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5572">
              Anyone on GLP-1 medications (Ozempic, Wegovy, Mounjaro, Zepbound)
              who has lost significant weight but still has stubborn pockets
              that won't respond to the medication.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5573">
              People already doing everything right who have that one area—lower
              belly, love handles, thighs—that won't change regardless of
              effort.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5574">
              Post-pregnancy women dealing with stubborn abdominal fat that
              persists despite returning to pre-pregnancy weight.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5575">
              Men with stubborn flank fat or lower belly that won't respond to
              caloric deficits or increased training.
            </FeaturePointRlt2>
            <FeaturePointRlt2 data-id="element-5576">
              Anyone who has tried red light therapy before and saw only skin
              benefits—your device probably couldn't reach the fat layer.
            </FeaturePointRlt2>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5577">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5578"></span>
            Who This Is NOT For
          </h2>

          <div className="space-y-3 mb-8 border border-red-200 p-5 bg-red-50 rounded" data-id="element-5579">
            <p className="text-base" data-id="element-5580">
              This is not a weight loss solution. If you need to lose
              significant body weight, address that first through nutrition and
              activity. This targets stubborn deposits on people already at or
              near a healthy weight.
            </p>
            <p className="text-base" data-id="element-5581">
              If you won't move after treatments, this won't work. The light
              mobilizes fat—your activity burns it. Without movement, the
              released fat gets reabsorbed into nearby cells.
            </p>
            
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5582">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5583"></span>
            The Protocol That Worked
          </h2>

          <p className="mb-5 text-base" data-id="element-5584">For volunteers who saw results:</p>

          <div className="border border-gray-300 p-5 my-6 bg-gray-50 rounded" data-id="element-5585">
            <ul className="space-y-2 text-base" data-id="element-5586">
              <li data-id="element-5587">• 20 minutes per session, 5 days per week</li>
              <li data-id="element-5588">
                • Applied directly to stubborn area (wrap must contact skin)
              </li>
              <li data-id="element-5589">• Followed by 30 minutes of movement—walking is enough</li>
              <li data-id="element-5590">
                • 8+ glasses of water daily to support lymphatic clearance
              </li>
              <li data-id="element-5591">
                • Consistency for minimum 6 weeks before evaluating results
              </li>
            </ul>
          </div>

          <p className="mb-6 text-base" data-id="element-5592">
            Most volunteers noticed their clothes fitting differently before
            seeing obvious mirror changes. Measurements improved before visual
            changes became apparent. Trust the tape measure over the mirror.
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5593">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5594">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5595">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5596" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5597">
              Limited to 340 units. Next production run ships in 6-8 weeks.
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5598">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5599"></span>
            What the Volunteers Said
          </h2>

          <div className="my-8" data-id="element-5600">
            <TestimonialCardRlt2 name="Jennifer, 49" location="Perimenopausal" duration="2 months" testimonial="I've spent two years watching my waist thicken despite doing everything the same. Two months with this and I'm buying new jeans. Not because I lost weight—the scale barely moved. But whatever was sitting around my middle is finally letting go." data-id="element-5601" />
            <TestimonialCardRlt2 name="Maria, 54" location="On Mounjaro" duration="8 weeks" testimonial="Mounjaro changed my life for the big weight. But this lower belly was just... stuck. Like the medication couldn't see it. Eight weeks with the Deep wrap and I measured 1.9 inches gone. More progress than the previous four months of medication for this specific area." data-id="element-5602" />
            <TestimonialCardRlt2 name="David, 58" location="Cyclist" duration="10 weeks" testimonial="I've had these love handles since my 40s. Hundreds of miles on the bike every month. Caloric deficits that should have stripped them. Nothing worked. This thing finally did. My cycling jerseys fit the way they're supposed to now." data-id="element-5603" />
            <TestimonialCardRlt2 name="Linda, 61" location="Post-menopausal" duration="10 weeks" testimonial="I thought this body was just... what I had now. Menopause took what it wanted and I had to accept it. Turns out I didn't. Turns out the right tool actually works. I wish I'd found this three years ago." data-id="element-5604" />
            <TestimonialCardRlt2 name="Michael, 52" location="Former athlete" duration="12 weeks" testimonial="I tried two different red light belts before this. Both did nothing for fat—my skin looked better, sure, but the belly stayed. I assumed I was a non-responder. Now I realize I just had devices that couldn't actually reach the fat. This one does. The results prove it." data-id="element-5605" />
            <TestimonialCardRlt2 name="Rachel, 38" location="Postpartum" duration="10 weeks" testimonial="Eighteen months of hating my body every time I looked in the mirror. Eighteen months of my husband telling me I looked fine when I knew I didn't feel fine. This pouch was a daily reminder of what pregnancy took from me. Now it's actually going away. I feel like myself again." data-id="element-5606" />
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5607">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5608"></span>
            My Professional Assessment
          </h2>

          <p className="mb-5 text-base" data-id="element-5609">
            After 12 weeks of controlled testing, here's what I can confidently
            state:
          </p>

          <div className="space-y-3 mb-8 border border-yellow-400 p-5 bg-yellow-50 rounded" data-id="element-5610">
            <p className="text-base" data-id="element-5611">
              <strong data-id="element-5612">1. The mechanism is real.</strong> Red light at 660nm
              wavelength can trigger transitory pore formation in adipocytes,
              releasing stored lipids. This is documented physics, not
              marketing.
            </p>
            <p className="text-base" data-id="element-5613">
              <strong data-id="element-5614">2. Most consumer devices can't deliver it.</strong> They
              were designed for skin benefits and later marketed for fat loss
              without engineering changes. The light scatters before reaching
              the fat layer in therapeutic concentration.
            </p>
            <p className="text-base" data-id="element-5615">
              <strong data-id="element-5616">3. Reflector-based delivery changes everything.</strong>{' '}
              The Glokore device's focused beam delivery produced 3-4x the
              results of standard designs with identical specifications.
            </p>
            <p className="text-base" data-id="element-5617">
              <strong data-id="element-5618">4. The results are sustained.</strong> Unlike the other
              devices that plateaued by week 4, the Glokore volunteers continued
              improving through week 12. The treatment is cumulative when the
              light actually reaches the target tissue.
            </p>
            <p className="text-base" data-id="element-5619">
              <strong data-id="element-5620">5. This isn't magic.</strong> You still need to move after
              treatment. You still need to stay hydrated. The device mobilizes
              fat; your body has to clear and burn it. But for people already
              doing those things, this removes the bottleneck.
            </p>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-5621">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-5622"></span>
            The Measurement Guarantee
          </h2>

          <p className="mb-5 text-base" data-id="element-5623">
            Rob insists on this: measure yourself before you start. Measure
            weekly. Track your results.
          </p>

          <p className="mb-6 text-base" data-id="element-5624">
            If your stubborn area isn't shrinking within 60 days of consistent
            use following the protocol, send it back. Full refund. He doesn't
            want your money if it doesn't work for you.
          </p>

          <p className="mb-6 text-base" data-id="element-5625">
            That's the confidence that comes from actual engineering, not
            marketing promises.
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-5626">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-5627">
              READER ACCESS
            </h3>
            <h4 className="text-lg font-medium text-gray-800 mb-3 text-center" data-id="element-5628">
              Glokore Deep Red Light Therapy Wrap
            </h4>
            <CTAButtonRlt1 data-id="element-5629" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-5630">
              Limited to 340 units from current production run.
            </div>
          </div>

          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-5631">
            <div className="flex items-center mb-4" data-id="element-5632">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-5633">
                <img src="https://cdn.magicpatterns.com/uploads/2GyeX4XySat8iU7eJrVRv7/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-5634" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-5635">
                <span className="font-medium" data-id="element-5636">
                  Dr. Sarah Mitchell, PhD | Exercise Physiology | University of
                  Texas [Verified]
                </span>
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5637">
              <strong data-id="element-5638">P.S.</strong> — If you've tried red light therapy before
              and only got skin benefits, you weren't scammed. The science is
              real. Those devices work for what they were designed for. They
              just can't reach the fat layer.
            </p>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5639">
              The Deep wrap exists because an engineer who spent 32 years making
              light penetrate the ocean floor asked one question: "Why isn't
              this reaching my wife's fat cells?"
            </p>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5640">
              Then he fixed it.
            </p>
            <p className="text-sm text-gray-700 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-5641">
              <strong data-id="element-5642">P.P.S.</strong> — Rob personally answers technical
              questions. His email is on the product page. When's the last time
              you could reach the actual engineer who built something—not
              customer service, not a chatbot, the engineer—and get a real
              answer?
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-5643">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-5644">
          <p className="mb-2 font-medium" data-id="element-5645">Important Disclaimer</p>
          <p className="mb-2" data-id="element-5646">
            The Glokore Deep Red Light Therapy Wrap mobilizes fat from targeted
            areas. It does not destroy fat cells or replace diet and exercise.
          </p>
          <p className="mb-2" data-id="element-5647">
            The released fat must be cleared by your lymphatic system (requires
            movement) and oxidized by your metabolism (requires caloric demand).
            If you use the wrap and remain sedentary, mobilized fat will be
            reabsorbed.
          </p>
          <p className="mb-2" data-id="element-5648">
            This technology works WITH your body's natural processes, not
            instead of them.
          </p>
          <p className="mb-2" data-id="element-5649">
            Continue your exercise routine. Continue eating well. Use this to
            finally see results in the areas that have never responded.
          </p>
          <p data-id="element-5650">
            Results vary based on individual physiology, consistency of use, and
            activity levels.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-5651"></div>
    </div>;
};
export default AdvertorialRlt2;